import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Pressable, StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Icon, TextBody } from '../../atoms';
export const StatusButton = ({ onPress, label, iconColor, disabled = false, }) => {
    return (_jsxs(Pressable, { onPress: onPress, style: ({ focused }) => [
            $.container,
            focused && $.focused,
            disabled && $.disabled,
        ], disabled: disabled, children: [_jsx(Icon, { name: "Circle", color: iconColor, size: "xxs" }), _jsx(TextBody, { small: true, color: "primary", style: $.label, children: label })] }));
};
const $ = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        columnGap: theme.spacing['1'],
        // @ts-expect-error This is web only
        outlineStyle: 'none',
    },
    label: {
        // @ts-expect-error This is web only
        outlineStyle: 'none',
    },
    focused: {
        // @ts-expect-error This is web only
        outlineStyle: 'none',
    },
    disabled: {
        opacity: 0.5,
    },
});
